const home = [
  {
    path: '/home/index',
    name: 'home_index',
    component: () => import( '@/pages/home/index'),
    meta: {keepAlive: true, name: '首页'},
  },

]

export default home



// WEBPACK FOOTER //
// ./src/router/modules/home.js